import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Input,
  Signal,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GlobalService, ScreenSizeService } from "@shared/services";
import { Hss } from "./models/hss";
import { ButtonModule } from "primeng/button";
import { RapItem } from "./models/history";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { HistoryService } from "../services/history.service";
import { HeaderComponent } from "./header/header.component";
import { HssBuilderService } from "./hss-builder.service";
import { SkdRowComponent } from "./skd-row/skd-row.component";
import { ReskdRowComponent } from "./reskd-row/reskd-row.component";
import { ActRowComponent } from "./act-row/act-row.component";
import { DpSummaryComponent } from "./dp-summary/dp-summary.component";
import { SeqSummaryComponent } from "./seq-summary/seq-summary.component";
import { SplitDutyRestComponent } from "./split-duty-rest/split-duty-rest.component";

@Component({
  selector: "app-hss-builder",
  standalone: true,
  templateUrl: "./hss-builder.component.html",
  styleUrl: "./hss-builder.component.scss",
  imports: [
    CommonModule,
    ButtonModule,
    OverlayPanelModule,
    HeaderComponent,
    SkdRowComponent,
    ReskdRowComponent,
    ActRowComponent,
    DpSummaryComponent,
    SeqSummaryComponent,
    SplitDutyRestComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HssBuilderComponent {
  route = inject(ActivatedRoute);
  screenSizeService = inject(ScreenSizeService);
  historyService = inject(HistoryService);
  globalService = inject(GlobalService);
  hssBuilderService = inject(HssBuilderService);

  fontSize = computed(() =>
    this.calculateFontSize(this.screenSizeService.screenWidth()),
  );

  @Input() hss?: Hss | null;
  @Input() theme?: string;
  @Input() enhanced?: boolean;
  @Input() index?: number;
  @Input() fontSizeOffset!: Signal<number>;
  @Input() stationTimeZones!: Record<string, string>;
  @Input() raps: RapItem[] = [];

  private calculateFontSize(screenWidth: number): number {
    const magicNumber = 0.51; // Constant to divide by to get optimal font size.
    const maxAutoFontSize = 18;
    const dialogMaxVw = 0.9; // Dialog max width as % vw.
    const paddingX = 8; // Mat dialog horizontal padding.
    const maxLength = 63;
    const usableWidth = screenWidth * dialogMaxVw - paddingX * 2;

    return (
      Math.min(usableWidth / maxLength / magicNumber, maxAutoFontSize) +
      (this.fontSizeOffset() || 0 * 0.5)
    );
  }
}
